module.exports = __webpack_public_path__ + "static/trust_agencyvista2-6464357d0beaba03be779fec1ebc8ad3.png";